// removed by extract-text-webpack-plugin
module.exports = {"container":"src-pages----words-module---container---2UGOR","link":"src-pages----words-module---link---1V5PU","date":"src-pages----words-module---date---2zM3o"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/words.module.css
// module id = 152
// module chunks = 93222003207436 94533468323174